import { createAction, props } from '@ngrx/store';
import { ItemConfigurationInputRequest, ItemConfigurationInputResponse } from '../../models/pricing-view-models';

export const updateItemConfigurationInputRequest = createAction(
  '[ItemConfigurationInput] Update Item Config Input Request',
  props<{ itemConfigurationInputRequest: ItemConfigurationInputRequest }>()
)
export const clearItemConfigurationInputRequest = createAction(
  '[ItemConfigurationInput] Clear Item Config Input Request'
)
export const loadItemConfigurationInputFromRequest = createAction(
    '[ItemConfigurationInput] Load Item Configuration Inputs from Request'
  );
export const getItemConfigurationInputResponseSuccess = createAction(
    '[ItemConfigurationInput] Item Config Input Response Success',
    props<{ itemConfigurationInputRequest: ItemConfigurationInputRequest; itemConfigurationInputResponse: ItemConfigurationInputResponse }>()
);
export const getItemConfigurationInputResponseFailure = createAction(
    '[ItemConfigurationInput] Item Config Input Response Failure',
    props<{ error: Error }>()
);
export const clearItemConfigurationInputResponse = createAction(
  '[ItemConfigurationInput] Clear Item Config Input Response'
);

//pricing inputs
export const clearPricingInputSearchRequest = createAction(
  '[ItemConfigurationInput] Clear Item Config Input Request'
)
export const loadAllPricingInputForSearchRequest = createAction(
  '[ItemConfigurationInput] Load Item Config Input Response'
);

